export const COMPONENT_NAME = 'footer';

export const OS_NAMES = {
  ANDROID: 'Android',
  IOS: 'iOS',
  OTHERS: 'Others',
} as const;

export const OS_NAME_EVENT_FIELD = {
  UNSET_OS_NAME: 'UNSET_OS_NAME',
  [OS_NAMES.ANDROID]: 'OS_NAME_ANDROID',
  [OS_NAMES.IOS]: 'OS_NAME_IOS',
  [OS_NAMES.OTHERS]: 'OS_NAME_OTHERS',
} as const;

export const PRODUCT_VERTICAL = {
  FLIGHTS: 'flights',
  CAR_HIRE: 'car-hire',
  HOTELS: 'hotels',
  PACKAGE: 'package',
} as const;

export const PRODUCT_VERTICAL_EVENT_FIELD = {
  UNSET_PRODUCT_VERTICAL: 'UNSET_PRODUCT_VERTICAL',
  [PRODUCT_VERTICAL.FLIGHTS]: 'PRODUCT_VERTICAL_FLIGHTS',
  [PRODUCT_VERTICAL.CAR_HIRE]: 'PRODUCT_VERTICAL_CAR_HIRE',
  [PRODUCT_VERTICAL.HOTELS]: 'PRODUCT_VERTICAL_HOTELS',
  [PRODUCT_VERTICAL.PACKAGE]: 'PRODUCT_VERTICAL_PACKAGE',
} as const;

export const EVENT_TYPE_EVENT_FIELD = {
  UNSET_EVENT_TYPE: 'UNSET_EVENT_TYPE',
  EVENT_TYPE_VISIBLE: 'EVENT_TYPE_VISIBLE',
  EVENT_TYPE_CLICK: 'EVENT_TYPE_CLICK',
} as const;

export const LOGGER_EVENT_NAME = {
  APP_CTA_IMPRESSION: 'APP CTA Impression',
};

export const ELEMENT_NAME = {
  APP_CTA: 'app-cta',
  CULTURE_BUTTON: 'culture-button',
} as const;

export type ProductVertical = (typeof PRODUCT_VERTICAL)[keyof typeof PRODUCT_VERTICAL];

export type EventType = (typeof EVENT_TYPE_EVENT_FIELD)[keyof typeof EVENT_TYPE_EVENT_FIELD];

type ValuesOf<T> = T[keyof T];

export type OsName = ValuesOf<typeof OS_NAMES>;

export type ElementName = ValuesOf<typeof ELEMENT_NAME>;

export type TrackingEventMessage = {
  element_name: ValuesOf<typeof ELEMENT_NAME>;
  culture: { locale: string; country: string; currency: string };
  page_type: string;
  event_type: ValuesOf<typeof EVENT_TYPE_EVENT_FIELD>;
  vertical: ValuesOf<typeof PRODUCT_VERTICAL_EVENT_FIELD>;
  os_name: ValuesOf<typeof OS_NAME_EVENT_FIELD>;
};
